import type { FC, ReactNode } from "react"
import { createContext, useContext } from "react"

export interface ApiReferenceLinkProps {
	/** A docs path tail: the tab slug, or `${tabSlug}/${groupSlug}/${slug}`. */
	to: string
	className?: string
	children: ReactNode
}

export interface ApiReferenceEnv {
	t: (key: string, fallback: string) => string
	Link: FC<ApiReferenceLinkProps>
	/** Font classes for the view root; menus portal out, so they get them too. */
	monoClassName?: string
	/** The dashboard keeps the default arrow on its controls. */
	showPointer?: boolean
}

const PlainLink: FC<ApiReferenceLinkProps> = ({ to, className, children }) => (
	<a href={to} className={className}>
		{children}
	</a>
)

const ApiReferenceEnvContext = createContext<ApiReferenceEnv>({
	t: (_key, fallback) => fallback,
	Link: PlainLink,
	showPointer: true,
})

export const ApiReferenceEnvProvider = ApiReferenceEnvContext.Provider

export function useApiReferenceEnv(): ApiReferenceEnv {
	return useContext(ApiReferenceEnvContext)
}

export function usePointerClass(): string | undefined {
	return useApiReferenceEnv().showPointer === false
		? undefined
		: "cursor-pointer"
}
